import React from 'react';
import EmotionDashboard from '../../dashboard/EmotionDashboard';

export const FlzEmotions: React.FC = () => {
  return (
    <div style={{ height: '100%', overflowY: 'auto', padding: 16 }}>
      <EmotionDashboard />
    </div>
  );
};
